import { computed, Directive } from '@angular/core';
import { FormArray, FormControl, FormGroup } from '@angular/forms';
import { InsuredObject } from '@models/insured-object';
import { InsuredObjectFormControl } from '@models/insured-object-form-config';
import { OrderStepBaseComponent } from './order-step-base-component';
import { OrderState } from './models';
import { compareInsuredObjects } from 'app/utils/helper.functions';

@Directive()
export class InsuredObjectsBaseComponent extends OrderStepBaseComponent<{ insuredObjects: InsuredObject[] }> {
    public form = new FormGroup({
        objects: new FormArray<FormGroup>([]),
    });
    public constructor() {
        super();
    }

    protected formConfig = computed(() => this.product()?.insuredObjectsForm);

    protected insuredObjects = computed(() => this._state()?.insuredObjects, {
        equal: compareInsuredObjects,
    });

    public addObject(): void {
        if (this.formConfig().max === -1 || this.form.controls.objects.length < this.formConfig().max) {
            this.generateFormGroup();
        }
    }

    public removeObject(index: number): void {
        if (this.form.controls.objects.length > index) {
            this.form.controls.objects.removeAt(index);
        }
    }

    protected setupForm(): void {
        this.form.controls.objects.clear();
        if (this.insuredObjects()?.length) {
            this.insuredObjects().forEach((insuredObject) => this.generateFormGroup(insuredObject));
        } else {
            this.addObject();
        }
    }

    protected generateFormGroup(insuredObject?: InsuredObject): void {
        try {
            const f: FormGroup = new FormGroup({});
            this.formConfig().controls.forEach((control: InsuredObjectFormControl) => {
                const preset: string | number | boolean | null =
                    control.preset ?? (control.type === 'checkbox' ? false : null);

                const ctrl = new FormControl(insuredObject?.[control.name] ?? preset, control.validators ?? []);
                f.addControl(control.name, ctrl);
            });
            this.form.controls.objects.push(f);
        } catch (err) {
            console.error(err);
        }
    }

    protected formToInsuredObjects(force: boolean = false): InsuredObject[] {
        const objects: InsuredObject[] = [];
        this.form.controls.objects.controls.forEach((control: FormGroup) => {
            if (control.valid || force) {
                objects.push({ ...control.value } as InsuredObject);
            }
        });
        return objects;
    }

    public getData(): Pick<OrderState, 'insuredObjects'> {
        return { insuredObjects: this.formToInsuredObjects(true) };
    }
}
